/* eslint-disable react/prop-types */
import React from 'react';
import Base from './src/Base';

const XFADE_MILLIS = 250;
const XFADE_MILLIS_LONG = 400;

const CrossFade = ({ className, childKey, long, children }) => (
  <Base
    classNames={long ? 'cross-fade-long' : 'cross-fade'}
    timeout={long ? XFADE_MILLIS_LONG : XFADE_MILLIS}
    className={className}
    childKey={childKey}
  >
    {children}
  </Base>
);

export default CrossFade;
